import { Injectable } from "@angular/core";
import { fromEvent } from "rxjs/observable/fromEvent";
import { interval } from "rxjs/observable/interval";
import { merge } from "rxjs/observable/merge";
import { debounce, takeUntil } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { Subject } from "rxjs";
import { AuthenticationService } from '../services/auth-service';

@Injectable()
export class ActivityService {
  private timeout: number = environment.INACTIVITY_MINUTES * 60 * 1000;
  private activityEvents = new Subject<void>();
  private showAlert = true;

  constructor(private authenticationService: AuthenticationService) {
    if (localStorage.getItem("token")) {
      this.initInactivityTimer();
    }
  }

  private initInactivityTimer() {
    const activityEvents$ = merge(
      fromEvent(document, "mousemove"),
      fromEvent(document, "keydown"),
      fromEvent(document, "scroll"),
      fromEvent(document, "click")
    );

    activityEvents$
      .pipe(
        debounce(() => interval(this.timeout)),
        takeUntil(this.activityEvents)
      )
      .subscribe(() => {
        if (this.showAlert) {
          this.emitAlert();
          this.showAlert = false;
        }
      });
  }

  private emitAlert() {
    this.authenticationService.logout(true);
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/activity-service.ts